import { network } from 'services/network';

import { QueryParams } from 'api/queries/clustersSearchWordsList.query';

export const getCustomClusterList = (params: QueryParams) => {
    const url = `api/bo/getCustomClusterList?customerId=${params}`;

    return network.post(url).then((response) => {
        return response.data;
    });
};
